export const faqs = [
  {
    question: '小蓝视频是免费的吗？',
    answer: '是的，小蓝视频完全免费使用。所有视频内容均可免费在线观看，无需任何付费。我们通过精准的推荐算法，让你发现更多感兴趣的内容。',
  },
  {
    question: '如何下载视频离线观看？',
    answer: '只需在视频播放页面点击下载按钮，即可将视频保存到本地。下载后可在"我的下载"中随时离线观看，无需网络连接。支持选择不同清晰度下载。',
  },
  {
    question: '小蓝视频支持哪些平台？',
    answer: '小蓝视频目前支持iOS和Android两大主流移动平台，可通过App Store和各大应用商店下载。同时也可以通过网页版在电脑上观看。',
  },
  {
    question: '如何上传自己的视频？',
    answer: '下载小蓝视频APP后，点击底部"+"按钮即可拍摄或从相册选择视频上传。支持最长15分钟的视频，上传后可添加标题、标签和封面图。',
  },
  {
    question: '视频推荐是怎样运作的？',
    answer: '小蓝视频采用先进的AI推荐算法，根据你的观看历史、点赞、收藏和搜索行为，智能推荐你可能感兴趣的内容。用得越多，推荐越精准。',
  },
  {
    question: '如何联系客服或反馈问题？',
    answer: '你可以通过APP内的"我的-帮助与反馈"提交问题，或发送邮件至 support@xiaolanvideo.com。我们的客服团队会在24小时内回复。',
  },
];